require('expose-loader?BVFetch!../src/utils/fetch');
